var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.207,
    height: 76.163,
    viewBox: "0 0 57.207 76.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_272",
    "data-name": "\\u8DEF\\u5F84 272",
    d: "M-8.192,58.047A18.3,18.3,0,0,0,1.6,41.936,18.361,18.361,0,0,0-16.764,23.592,18.327,18.327,0,0,0-35.088,41.936a18.306,18.306,0,0,0,9.754,16.112A28.7,28.7,0,0,0-45.357,85.324V99.755H11.85V85.324A28.692,28.692,0,0,0-8.192,58.047Z",
    transform: "translate(45.357 -23.592)",
    fill: "#b8b8b8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.dbe8e8ccdb2bf224f212d3cb8e19cbd7.svg";
export { ForwardRef as ReactComponent };